import { v4 as uuidv4 } from 'uuid';

import { SEARCH_ID_STORAGE_KEY } from './constants';

import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/modules/storage';

export function createNewSearchId(newSearchId = uuidv4()) {
  setSessionStorageItem(SEARCH_ID_STORAGE_KEY, newSearchId);
}

export function getOrCreateNewSearchId(): string {
  const existingSearchId = getSessionStorageItem(SEARCH_ID_STORAGE_KEY);
  if (existingSearchId) {
    return existingSearchId;
  }

  const newSearchId = uuidv4();

  createNewSearchId(newSearchId);

  return newSearchId;
}
